import clsx from "clsx";
import { getCompany } from "@/entities/Company";
import { useApiQuery } from "@/api";

export function PageHeading() {
    const company = useApiQuery(getCompany);

    return (
        <div className={clsx("sm:mb-4")}>
            <div className="flex justify-between">
                <h1 className="display-l">{company.data?.name}</h1>
            </div>
        </div>
    );
}
